export const showModal = id => dispatch => {
  return dispatch({
    type: 'SHOW_MODAL',
    id,
  });
};

export const hideModal = id => dispatch => {
  return dispatch({
    type: 'HIDE_MODAL',
    id,
  });
};

export const clearPageError = route => dispatch => {
  return dispatch({
    type: 'CLEAR_PAGE_ERROR',
    route,
  });
};

export const toggleModal = id => dispatch => {
  return dispatch({
    type: 'TOGGLE_MODAL',
    id,
  });
};

export const showConfirmationDialog = (name, settings) => dispatch => {
  return dispatch({
    type: 'SHOW_CONFIRMATION_DIALOG',
    name,
    settings,
  });
};

export const clearConfirmationDialog = () => dispatch => {
  return dispatch({
    type: 'CLEAR_CONFIRMATION_DIALOG',
  });
};

export const respondToConfirmationDialog = (name, response) => dispatch => {
  return dispatch({
    type: 'RESPOND_TO_CONFIRMATION_DIALOG',
    name,
    response,
  });
};
